import Section from '../elements/Section';
import Card from '../elements/Card';
import Button from '../elements/Button';
import { CornerUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { RefObject } from 'react';
import { forwardRef } from 'react';

interface LandingWhoWeServeProps {
  content: {
    title: string;
    description: string;
    cards: Array<{
      title: string;
      description: string;
    }>;
    cta?: {
      text: string;
      link: string;
    };
  };
  ref?: RefObject<HTMLDivElement>;
  background?: 'grey' | 'white';
}

const LandingWhoWeServe = forwardRef<HTMLDivElement, LandingWhoWeServeProps>(
  ({ content, background = 'grey' }, ref) => {
    const navigate = useNavigate();

    return (
      <Section
        id='who-we-serve'
        ref={ref}
        background={background}
        title={content.title}
        description={content.description}
      >
        <div className='mt-8 grid grid-cols-1 gap-6 md:grid-cols-3'>
          {content.cards.map((card, index) => (
            <Card
              key={index}
              title={card.title}
              description={card.description}
              background={background === 'grey' ? 'white' : 'grey'}
            >
              {content.cta && (
                <div className='mt-auto'>
                  <Button
                    buttonText={content.cta.text}
                    className='w-[max-content] mt-6 mb-0 flex items-center'
                    onClick={() => content.cta && navigate(content.cta.link)}
                  >
                    <CornerUpRight className='size-4 mb-1 ml-2' />
                  </Button>
                </div>
              )}
            </Card>
          ))}
        </div>
      </Section>
    );
  }
);

LandingWhoWeServe.displayName = 'LandingWhoWeServe';

export default LandingWhoWeServe;
